<div nz-row class="meal-plan-card card-container-shadow tw-overflow-hidden"
  [ngClass]="{'tw-pt-0': this.mealTime.valid === false}">

  <div nz-col [nzXs]="24" [nzLg]="24">
    <div *ngIf="this.mealTime.valid === false" class="tw-text-orange-800/80 tw-text-xs tw-text-center"
      style="margin: 0 -20px 10px -20px; padding: 5px 20px; background-color: rgb(230 107 21 / 15%);">Tiempo de comida
      incompleto</div>

    <div class="meal-plan-card-header tw-flex tw-gap-4">
      <input #titleInput type="text" [required]="true" nz-input placeholder="Nombre del tiempo de comida"
        class="input-name-time-food" [(ngModel)]="mealTime.title">
      <div class="meal-plan-card-options">
        <div class="hour">
          <nz-time-picker [nzPlaceHolder]="'Hora'" [(ngModel)]="mealTime.datetime" nzFormat="HH:mm" style="width: 100%;"
            (ngModelChange)="onSetHasTime($event)"></nz-time-picker>
        </div>
      </div>
    </div>


    <div class="meal-plan-card-line mb-xs mt-xs"></div>
  </div>

  <div nz-col [nzXs]="24" [nzLg]="12">

    <p class="mb-sm text-info">Agregar un tipo</p>
    <div class="mb-sm type-container">
      <app-card-icon-text *ngFor="let type of blockPeriodTypes; index as i" (click)="addBlock(type.id)" size="small"
        class="cursor-pointer meal-plan-type-{{i}}" [value]="type"></app-card-icon-text>
    </div>

    <ng-container *ngFor="let block of mealTime.blockPeriods; index as i">
      <nz-collapse [nzExpandIconPosition]="'start'" [nzBordered]="false" [nzAccordion]="false" [class.invalid-block]="!block.valid"
        class="tw-shadow-none tw-mb-2">
        <nz-collapse-panel [nzHeader]="panelHeaderIconType" [nzActive]="false" [nzExtra]="panelHeaderIconDelete">
          <ng-container [ngSwitch]="block.type">
            <ng-container *ngSwitchCase="blockPeriodTypeEnum.FOOD_GROUP">
              <app-food-group-form (changeBlockPeriod)="onEmitPutMealTime($event)" [blockPeriod]="block"
                [clinicId]="clinicId"></app-food-group-form>
            </ng-container>
            <ng-container *ngSwitchCase="blockPeriodTypeEnum.INDIVIDUAL">
              <app-individual-form (changeBlockPeriod)="onEmitPutMealTime($event)" [blockPeriod]="block"
                [clinicId]="clinicId"></app-individual-form>
            </ng-container>
            <ng-container *ngSwitchCase="blockPeriodTypeEnum.INSTRUCTION">
              <app-instruction-form (changeBlockPeriod)="onEmitPutMealTime($event)" [blockPeriod]="block"
                [clinicId]="clinicId"></app-instruction-form>
            </ng-container>
          </ng-container>
        </nz-collapse-panel>
        <ng-template #panelHeaderIconDelete>

          <div class="delete-childBlock" (click)="deleteBlock(i)">
            <i nz-icon nzType="close" nzTheme="outline" class="mr-xxs"></i>
          </div>

        </ng-template>
        <ng-template #panelHeaderIconType>
          <div class="tw-flex">
            <ng-container *ngIf="block.type === blockPeriodTypeEnum.INDIVIDUAL && block.ingredients.length === 1; else generalIcon">
              <img  [src]="iconsRoute + iconsName[block.ingredients[0].category._id]" alt="" class="tw-h-4 tw-mr-1">
            </ng-container>
    
            <ng-template #generalIcon>
              <img [src]="periodTypesIconsMap[block.type]" alt="" class="tw-h-4 tw-mr-1">
            </ng-template>

            <p class="text-subtitle-bold-upper">{{ block.title }}</p>
          </div>
        </ng-template>
      </nz-collapse>
    </ng-container>


    <div *ngIf="mealTime.blockPeriods.length > 0" class="meal-plan-card-line mb-xs mt-xs"></div>

    <div class="macronutrients d-flex justify-content-between mb-md" @fadeInAnimation>
      <div class="macronutrient">
        <p class="text-info-bold-xs mb-xxs opacity-70">Calorías</p>
        <p class="text-info text-bold">{{ mealTime?.nutritionalProperties?.energy_kcal?.toFixed(2) || 0 }} kcal</p>
      </div>
      <div class="macronutrient">
        <p class="text-info-bold-xs mb-xxs opacity-70">Grasas</p>
        <p class="text-info text-bold">{{ mealTime?.nutritionalProperties?.totalFat_g?.toFixed(2) || 0 }} g</p>
      </div>
      <div class="macronutrient">
        <p class="text-info-bold-xs mb-xxs opacity-70">Carbohidratos</p>
        <p class="text-info text-bold">{{ mealTime?.nutritionalProperties?.carbohydrate_g?.toFixed(2) || 0 }} g</p>
      </div>
      <div class="macronutrient">
        <p class="text-info-bold-xs mb-xxs opacity-70">Proteínas</p>
        <p class="text-info text-bold">{{ mealTime?.nutritionalProperties?.protein_g?.toFixed(2) || 0 }} g</p>
      </div>
      <div class="macronutrient">
        <p class="text-info-bold-xs mb-xxs opacity-70">Fibra</p>
        <p class="text-info text-bold">{{ mealTime?.nutritionalProperties?.dietaryFiber_g?.toFixed(2) || 0 }} g</p>
      </div>
    </div>
  </div>


  <div nz-col [nzXs]="24" [nzLg]="12" class="tw-pl-8">
    <ng-container *ngIf="toggleCategoryReq">
      <app-category-requirements [mealTime]="mealTime"></app-category-requirements>
    </ng-container>
  </div>

  <div nz-col [nzXs]="24" [nzLg]="24">
    <div class="mt-xlg d-flex justify-content-end">
      <button nz-button nzDanger nzType="primary" class="mr-xs" (click)="onCancel()">
        <i nz-icon nzType="close-circle" nzTheme="outline"></i>
        Cancelar</button>
      <button class="btn-save-time-food" nz-button nzType="primary" (click)="onSave()">
        <i nz-icon nzType="save" nzTheme="outline"></i>
        Guardar
      </button>
    </div>
  </div>
</div>